export default function CsharpCodeStructure() {
  return (
    <h2>Csharp Code Structure</h2>
  );
}
